import * as React from "react";
import { connect } from "react-redux";
import { Route, withRouter } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import StaticHtmlContent from "../common/staticHtmlContent";
import * as d from "../../reducers/domainReducer";
import { getFirstName } from "../../helpers/formatting";
import { CovidScreeningModalSessionKeyInitial } from "../../constants/textConstants";
import { UncontrolledTooltip } from 'reactstrap';

class COVIDScreeningModal extends React.Component {
    constructor(props) {
        super(props);
        this.closeModal = this.closeModal.bind(this);
        this.getStarted = this.getStarted.bind(this);
        this.state = {
            modalVisible: props.shouldShowCovidModal
        };
    }

    componentDidMount() {
        logUI("MBHWeb.UI.COVIDScreeningModal.ComponentDidMount", new Date(), Tools.getURLPath());
        this.createSessionKeyForCOVID19();
        if (this.state.modalVisible)
            logUI("MBHWeb.UI.COVIDScreeningModal.Displayed", new Date(), Tools.getURLPath(), this.getActivityJson());        
    }

    createSessionKeyForCOVID19() {
        const { userName, currentMyChartUser } = this.props;        
        // adding userName to the key as while logout we want to clear all keys related to this user.
        this.sessionKey =  currentMyChartUser && currentMyChartUser.displayName && currentMyChartUser.eid ?
            userName + '_' + currentMyChartUser.displayName + '_' + currentMyChartUser.eid : userName;
    }

    getActivityJson() {
        let activityJson = {};
        const { currentMyChartUser, isProxyUser } = this.props;
        try {
            const displayName = currentMyChartUser && currentMyChartUser.displayName ? currentMyChartUser.displayName : "";
            activityJson = { displayName: displayName, isProxyUser: isProxyUser, sessionKey: this.sessionKey };
        } catch (err) {
            console.log(err);
        }
        return activityJson;
    }

    getStarted() {
        const { isProxyUser } = this.props;
        logUI("MBHWeb.UI.COVIDScreeningModal.GetStarted", new Date(), Tools.getURLPath(), this.getActivityJson());
        this.props.history.push({
            pathname: '/evisit',
            state: { isCovidScreeningModalForProxy: isProxyUser ? true : false }
        });
    }

    closeModal() {
        this.setState({ modalVisible: false });
        Tools.setItemToSessionStorage(CovidScreeningModalSessionKeyInitial + this.sessionKey, true);
        logUI("MBHWeb.UI.COVIDScreeningModal.Closed", new Date(), Tools.getURLPath(), this.getActivityJson());
    }

    render() {
        const { modalVisible } = this.state;
        const { serverData, currentMyChartUser, isProxyUser } = this.props;
        const COVID19ModalText = serverData && serverData.covid19ModalText ? serverData.covid19ModalText : "For your safety and convenience, we are encouraging all patients experiencing flu-like symptoms (cough, shortness of breath and feeling feverish) to take a free COVID-19 screening questionnaire. We ask that you please complete this prior to scheduling an appointment or walking into a clinic, urgent care or hospital emergency department.";

        const activeUserFirstName = currentMyChartUser ? currentMyChartUser.firstName ? currentMyChartUser.firstName : currentMyChartUser.displayName ? getFirstName(currentMyChartUser.displayName) : "" : "";

        const covid19ModalHeaderText = serverData && serverData.covid19ModalHeaderText ? serverData.covid19ModalHeaderText : "COVID-19 Safety";
        const COVID19ModalButtonText = serverData && serverData.covid19ModalButtonText ? serverData.covid19ModalButtonText : "";
        const COVID19ModalDismissText = serverData && serverData.covid19ModalDismissText ?
            isProxyUser ? serverData.covid19ModalDismissText + ' ' + activeUserFirstName : serverData.covid19ModalDismissText + " Me" : isProxyUser ? "None of These Apply To " + activeUserFirstName : "None of These Apply To Me";
        const covid19ModalToolTips = serverData && serverData.covid19ModalToolTips ? serverData.covid19ModalToolTips : null;
        const toolTipMarkup = {};
        if (covid19ModalToolTips) {
            const toolTipData = covid19ModalToolTips.split("~");
            for (let tooltip of toolTipData) {
                const [target, text] = tooltip.split("^");
                if(target && text)
                    toolTipMarkup[target] = text;               
            }
        }        
        const tooltips = toolTipMarkup && Object.keys(toolTipMarkup) && Object.keys(toolTipMarkup).length > 0 && Object.keys(toolTipMarkup).map(key => (<UncontrolledTooltip key={key}
            placement={"top"}
            autohide={false}
            className="covid-modal-tooltip"
            target={key}>      
            <StaticHtmlContent content={toolTipMarkup[key]} classname={`${key}-container`} />
        </UncontrolledTooltip>));
        return (
            <div>
                <Modal className="COVID-modal" isOpen={modalVisible} centered backdrop="static">
                    <ModalHeader>
                        <div className="row covid-modal-header">
                            <div className="col-12">
                                <span>
                                    {covid19ModalHeaderText}
                                </span>
                            </div>
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        <div className="row">
                            <div className="col-12">
                                <StaticHtmlContent content={COVID19ModalText} />
                                <div className="row">
                                    <div className="col-12 text-center">
                                        {COVID19ModalButtonText && <button type="button" className="btn btn-primary" onClick={() => this.closeModal()}> {COVID19ModalButtonText}</button>}
                                    </div>
                                </div>
                                {serverData && serverData.covid19ModalDismissText && <div className="row">
                                    <div className="col-12 text-center">
                                        <button
                                            type="button"
                                            className="btn text-btn"
                                            onClick={() => this.closeModal()}
                                        >
                                            <StaticHtmlContent content={COVID19ModalDismissText} />
                                        </button>
                                    </div>
                                </div>}
                            </div>
                        </div>
                        {tooltips}                        
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userName: state.domain.un,
        isProxyUser: state.domain.ip,        
        currentMyChartUser: d.hydrateProxyUser(state.domain.cu),
        serverData: state.session.serverData,
        primaryUser: d.hydrateProxyUser(state.domain.pu),        
        showCOVID19Modal: state.session.serverData && state.session.serverData.showCOVID19Modal ? state.session.serverData.showCOVID19Modal : false,
        hasMyChartLogin: state.domain.hm
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(COVIDScreeningModal));

